import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setK3Agents, getK3Agent } from '../../actions';
import { useLocation } from 'react-router-dom';
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Badge,
  InputGroup,
  Modal,
  Toast,
  ToastContainer
} from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { BsPencil, BsCheck2, BsX, BsTrash, BsCopy } from 'react-icons/bs';

class K3AgentView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      agent: props.selectedAgent || { ...props.agent },
      preview: false,
      showDeleteConfirm: false,
      showToast: false,
      toastMessage: '',
      toastType: 'success'
    };
  }

  componentDidMount() {
    if (this.props.selectedAgent) {
      this.setState({ agent: this.props.selectedAgent });
    } else {
      const { id } = this.props.match.params;
      if (id) {
        this.props.getK3Agent(id);
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedAgent && this.props.selectedAgent !== prevProps.selectedAgent) {
      this.setState({ agent: this.props.selectedAgent });
    } else if (this.props.currentAgent && this.props.currentAgent !== prevProps.currentAgent) {
      this.setState({ agent: { ...this.props.currentAgent } });
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      agent: {
        ...prevState.agent,
        [name]: value
      }
    }));
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { _id, ...agentData } = this.state.agent;
      const updatedAgent = {
        ...agentData,
        tags: Array.isArray(agentData.tags) ? agentData.tags : agentData.tags.split(',').map(tag => tag.trim()).filter(Boolean),
        supported_task_types: Array.isArray(agentData.supported_task_types) ? agentData.supported_task_types : agentData.supported_task_types.split(',').map(type => type.trim()).filter(Boolean)
      };
      await this.props.setK3Agents([{ _id, ...updatedAgent }]);
      this.setState({ isEditing: false });
    } catch (error) {
      console.error('Error updating agent:', error);
    }
  };

  toggleEdit = () => {
    this.setState(prevState => ({
      isEditing: !prevState.isEditing,
      agent: { ...prevState.agent }
    }));
  };

  togglePreview = () => {
    this.setState(prevState => ({ preview: !prevState.preview }));
  };

  handleDelete = async () => {
    try {
      const { _id } = this.state.agent;
      await this.props.setK3Agents([{ _id, is_deleted: true }]);
      this.setState({ showDeleteConfirm: false });
      if (this.props.onHide) {
        this.props.onHide();
      } else {
        this.props.history.push('/k3agent');
      }
    } catch (error) {
      console.error('Error deleting agent:', error);
    }
  };

  handleCopy = (text, fieldName) => {
    navigator.clipboard.writeText(text);
    this.setState({
      showToast: true,
      toastMessage: `${fieldName} copied to clipboard!`,
      toastType: 'success'
    });
    setTimeout(() => {
      this.setState({ showToast: false });
    }, 3000);
  };

  renderContent() {
    const { agent, isEditing, preview } = this.state;

    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1>
            {isEditing ? (
              <Form.Control
                type="text"
                name="name"
                value={agent.name}
                onChange={this.handleChange}
                className="h1"
              />
            ) : (
              agent.name
            )}
          </h1>
        </div>

        <Form.Group className="mb-4">
          <Form.Label>ID</Form.Label>
          <div style={{ position: 'relative' }}>
            <Form.Control
              type="text"
              value={agent._id}
              readOnly
              style={{ paddingRight: '40px' }}
            />
            <Button 
              variant="outline-secondary" 
              onClick={() => this.handleCopy(agent._id, 'ID')}
              style={{
                position: 'absolute',
                right: '5px',
                top: '50%',
                transform: 'translateY(-50%)',
                padding: '0.25rem 0.5rem',
                border: 'none',
                background: 'transparent'
              }}
            >
              <BsCopy />
            </Button>
          </div>
        </Form.Group>

        <Row className="mb-4">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Main Type</Form.Label>
              {isEditing ? (
                <Form.Select
                  name="main_type"
                  value={agent.main_type}
                  onChange={this.handleChange}
                >
                  <option value="HUMAN">Human</option>
                  <option value="AI">AI</option>
                  <option value="MACHINE">Machine</option>
                </Form.Select>
              ) : (
                <Form.Control
                  type="text"
                  value={agent.main_type}
                  readOnly
                />
              )}
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Sub Type</Form.Label>
              {isEditing ? (
                <Form.Control
                  type="text"
                  name="sub_type"
                  value={agent.sub_type}
                  onChange={this.handleChange}
                />
              ) : (
                <Form.Control
                  type="text"
                  value={agent.sub_type}
                  readOnly
                />
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Status</Form.Label>
              {isEditing ? (
                <Form.Control
                  type="text"
                  name="status"
                  value={agent.status}
                  onChange={this.handleChange}
                  placeholder="e.g. active, inactive, maintenance"
                />
              ) : (
                <Form.Control
                  type="text"
                  value={agent.status}
                  readOnly
                />
              )}
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Availability</Form.Label>
              {isEditing ? (
                <Form.Select
                  name="availability"
                  value={agent.availability}
                  onChange={this.handleChange}
                >
                  <option value={true}>Available</option>
                  <option value={false}>Unavailable</option>
                </Form.Select>
              ) : (
                <Form.Control
                  type="text"
                  value={agent.availability ? 'Available' : 'Unavailable'}
                  readOnly
                />
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Created At</Form.Label>
              <Form.Control
                type="text"
                value={new Date(agent.createdAt).toLocaleString()}
                readOnly
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Updated At</Form.Label>
              <Form.Control
                type="text"
                value={new Date(agent.updatedAt).toLocaleString()}
                readOnly
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-4">
          <Form.Label>Description</Form.Label>
          <div style={{ position: 'relative' }}>
            {isEditing ? (
              <Form.Control
                as="textarea"
                name="description"
                value={agent.description}
                onChange={this.handleChange}
                rows={3}
                style={{ paddingRight: '40px' }}
              />
            ) : (
              <Form.Control
                as="textarea"
                value={agent.description}
                readOnly
                rows={3}
                style={{ paddingRight: '40px' }}
              />
            )}
            <Button 
              variant="outline-secondary" 
              onClick={() => this.handleCopy(agent.description, 'Description')}
              style={{
                position: 'absolute',
                right: '5px',
                top: '5px',
                padding: '0.25rem 0.5rem',
                border: 'none',
                background: 'transparent'
              }}
            >
              <BsCopy />
            </Button>
          </div>
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>Tags</Form.Label>
          {isEditing ? (
            <Form.Control
              type="text"
              name="tags"
              value={Array.isArray(agent.tags) ? agent.tags.join(', ') : agent.tags}
              onChange={this.handleChange}
              placeholder="tag1, tag2, tag3"
            />
          ) : (
            <div>
              {Array.isArray(agent.tags) ? agent.tags.map(tag => (
                <Badge key={tag} bg="secondary" className="me-1">
                  {tag}
                </Badge>
              )) : agent.tags}
            </div>
          )}
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>Supported Task Types</Form.Label>
          {isEditing ? (
            <Form.Control
              type="text"
              name="supported_task_types"
              value={Array.isArray(agent.supported_task_types) ? agent.supported_task_types.join(', ') : agent.supported_task_types}
              onChange={this.handleChange}
              placeholder="type1, type2, type3"
            />
          ) : (
            <div>
              {Array.isArray(agent.supported_task_types) ? agent.supported_task_types.map(type => (
                <Badge key={type} bg="info" className="me-1">
                  {type}
                </Badge>
              )) : agent.supported_task_types}
            </div>
          )}
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>Metadata</Form.Label>
          <div style={{ position: 'relative' }}>
            {isEditing ? (
              <Form.Control
                as="textarea"
                name="metadata"
                value={JSON.stringify(agent.metadata, null, 2)}
                onChange={this.handleChange}
                rows={5}
                style={{ paddingRight: '40px' }}
              />
            ) : (
              <Form.Control
                as="textarea"
                value={JSON.stringify(agent.metadata, null, 2)}
                readOnly
                rows={5}
                style={{ paddingRight: '40px' }}
              />
            )}
            <Button 
              variant="outline-secondary" 
              onClick={() => this.handleCopy(JSON.stringify(agent.metadata, null, 2), 'Metadata')}
              style={{
                position: 'absolute',
                right: '5px',
                top: '5px',
                padding: '0.25rem 0.5rem',
                border: 'none',
                background: 'transparent'
              }}
            >
              <BsCopy />
            </Button>
          </div>
        </Form.Group>
      </>
    );
  }

  render() {
    const { selectedAgent, show, onHide } = this.props;
    const { showDeleteConfirm, isEditing, showToast, toastMessage, toastType } = this.state;

    if (selectedAgent) {
      return (
        <>
          <Modal show={show} onHide={onHide} size="xl">
            <Modal.Header closeButton className="pl-5 pr-5">
              <div className="d-flex justify-content-between align-items-center w-100">
                <Modal.Title>Agent Details</Modal.Title>
                <Button 
                  variant="primary"
                  onClick={isEditing ? this.handleSubmit : this.toggleEdit}
                >
                  {isEditing ? (
                    <>
                      <BsCheck2 className="me-1" /> Save
                    </>
                  ) : (
                    <>
                      <BsPencil className="me-1" /> Edit
                    </>
                  )}
                </Button>
              </div>
            </Modal.Header>
            <Modal.Body className="pl-5 pr-5">
              {this.renderContent()}
            </Modal.Body>
            <Modal.Footer className="p-5 pt-0">
              <Button variant="danger" onClick={() => this.setState({ showDeleteConfirm: true })}>
                <BsTrash className="me-1" /> Delete
              </Button>
              <Button variant="secondary" onClick={onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal show={showDeleteConfirm} onHide={() => this.setState({ showDeleteConfirm: false })}>
            <Modal.Header closeButton>
              <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to delete this agent? This action cannot be undone.
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => this.setState({ showDeleteConfirm: false })}>
                Cancel
              </Button>
              <Button variant="danger" onClick={this.handleDelete}>
                Delete
              </Button>
            </Modal.Footer>
          </Modal>

          <ToastContainer position="top-end" className="p-3">
            <Toast 
              show={showToast} 
              onClose={() => this.setState({ showToast: false })}
              bg={toastType}
              delay={3000}
              autohide
            >
              <Toast.Header closeButton={false}>
                <strong className="me-auto">Success</strong>
              </Toast.Header>
              <Toast.Body className="text-white">
                {toastMessage}
              </Toast.Body>
            </Toast>
          </ToastContainer>
        </>
      );
    }

    return (
      <Container className="py-4">
        {this.renderContent()}
      </Container>
    );
  }
}

const K3AgentViewWithRouter = (props) => {
  const location = useLocation();
  return <K3AgentView {...props} location={location} />;
};

const mapStateToProps = (state) => ({
  currentAgent: state.k3agentReducer.currentAgent,
});

export default connect(mapStateToProps, { setK3Agents, getK3Agent })(K3AgentViewWithRouter); 